import React from 'react';
import styles from './Icons.module.scss';

type ZoomInButtonProps = {
  onClick: () => void;
}

const ZoomInButton: React.FC<ZoomInButtonProps> = ({onClick}) => {
  return(
    <div onClick={onClick} className={styles.ZoomInButton}>
      <div className={styles.ZoomInIcon} />
    </div>
  )
}

export default ZoomInButton;



